
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/footerItems/policies/cancelPolicy",
      function () {
        return require("private-next-pages/footerItems/policies/cancelPolicy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/footerItems/policies/cancelPolicy"])
      });
    }
  